import FieldContainer from '../../../../shared/FormElements/FieldContainer/FieldContainer';
import RcSelect from '../../../../shared/FormElements/Selects/RcSelect';

const howOftenWearOptions = [
  { id: 'every_night', name: 'Every Night' },
  { id: 'a_few_times_per_week', name: 'A few times per week' },
  { id: 'daily', name: 'Daily (day and night)' },
  { id: 'as_needed', name: 'As needed' },
  { id: 'rarely', name: 'Rarely' },
];

function WarrantyFormHowOftenWear() {
  return (
    <FieldContainer
      name="howOftenWear"
      label="How often are retainers worn?"
      required={true}
    >
      <RcSelect
        name="howOftenWear"
        data={howOftenWearOptions}
        clearable={false}
      />
    </FieldContainer>
  );
}

export default WarrantyFormHowOftenWear;
